// Shared utility for task type detection and action button configuration
// Extracted from OverdueTaskCard to be reused across all task card components

import { getDeepLinkForTask, generateCollegeStrategyDeepLink } from './deepLinkUtils';

export const getTaskType = (task) => {
  const title = (task.title || task.task_name || '').toLowerCase();

  if (title.includes('essay')) {
    return {
      label: 'ESSAY',
      color: 'bg-azure-100 text-azure-700',
      actionText: 'Write Essay'
    };
  }

  if (title.includes('application') || title.includes('apply')) {
    return {
      label: 'APPLICATION',
      color: 'bg-violet-100 text-violet-800',
      actionText: 'Continue App'
    };
  }

  if (title.includes('recommendation') || title.includes('rec')) {
    return {
      label: 'RECOMMENDATION',
      color: 'bg-emerald-100 text-emerald-800',
      actionText: 'Follow Up'
    };
  }

  if (title.includes('transcript') || title.includes('document')) {
    return {
      label: 'DOCUMENTS',
      color: 'bg-amber-100 text-amber-700',
      actionText: 'Submit Docs'
    };
  }

  if (title.includes('scholarship')) {
    return {
      label: 'SCHOLARSHIP',
      color: 'bg-amber-100 text-amber-800',
      actionText: 'Apply Now'
    };
  }

  return {
    label: 'TASK',
    color: 'bg-slate-100 text-slate-800',
    actionText: 'Take Action'
  };
};

// Navigation logic for action buttons
export const handleTaskAction = (task, navigate) => {
  // If task has a specific college journey link, use that
  if (task.college_journey_link) {
    navigate(task.college_journey_link);
    return;
  }

  // If task is associated with a specific college, try to generate a deep link
  if (task.college_id) {
    const deepLink = getDeepLinkForTask(task, task.college_id);

    if (deepLink) {
      // Found a specific deep link based on task content
      navigate(deepLink.url);
      return;
    }

    // No specific section match, but still navigate to college strategy page
    // Determine which tab based on task type
    const title = (task.title || task.task_name || '').toLowerCase();
    let tab = 'strategy'; // default tab

    if (title.includes('value proposition') || title.includes('unique value') || title.includes('why this school')) {
      tab = 'strategy';
    } else if (title.includes('research') || title.includes('programs') || title.includes('campus')) {
      tab = 'research';
    } else if (title.includes('application') || title.includes('requirement') || title.includes('component')) {
      tab = 'application';
    } else if (title.includes('action') || title.includes('improve') || title.includes('odds')) {
      tab = 'actions';
    }

    navigate(generateCollegeStrategyDeepLink(task.college_id, tab));
    return;
  }

  // Otherwise, navigate based on general task type (not college-specific)
  const title = (task.title || task.task_name || '').toLowerCase();

  if (title.includes('essay')) {
    // Navigate to essay writing section
    navigate('/college/essay-hub');
  } else if (title.includes('application') || title.includes('apply')) {
    // Navigate to application tracking
    navigate('/college/applications');
  } else if (title.includes('recommendation') || title.includes('rec')) {
    // Navigate to recommendation tracker
    navigate('/college/recommendations');
  } else if (title.includes('transcript') || title.includes('document')) {
    // Navigate to document upload
    navigate('/college/documents');
  } else if (title.includes('scholarship')) {
    // Navigate to scholarship tracker
    navigate('/college/scholarships');
  } else {
    // Default fallback - navigate to college journey hub
    navigate('/college');
  }
};